import ReactDOM from 'react-dom';

class Overlay extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      active: true,
    };
  }

  componentDidMount = () =>
    window.addEventListener('keydown', this.onModalKeyDown, true);

  componentWillUnmount = () =>
    window.removeEventListener('keydown', this.onModalKeyDown, true);

  escKeyCode = 27;

  onModalKeyDown = (event) => {
    if (event.keyCode === this.escKeyCode) {
      event.preventDefault();
      this.fadeClose();
    }
  };
  getClassName = () => {
    const { active } = this.state;

    return classnames('cb-overlay', {
      'cb-active': active,
      'cb-inactive': !active,
    });
  };

  fadeClose = () => {
    this.setState({ active: false });
    setTimeout(this.close, 320);
  };

  close = () => {
    if (this.props.onClose) {
      this.props.onClose();
    } else {
      const node = ReactDOM.findDOMNode(this);
      ReactDOM.unmountComponentAtNode(node.parentNode);
    }
  };

  onCheckClose = (event) => {
    if (event.target === event.currentTarget) {
      return this.fadeClose();
    }
  };

  render() {
    const { children } = this.props;

    return (
      <div className={this.getClassName()} onClick={this.onCheckClose}>
        <div className="cb-modal">
          {React.cloneElement(children, { onCloseOverlay: this.fadeClose })}
        </div>
      </div>
    );
  }
}

Overlay.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  onClose: PropTypes.func,
};

export default Overlay;
